/**
 * Single review transformation (detail view).
 * Used by review store for setCurrentReview and setCurrentFormSubmission.
 */
export function flattenReview(review) {
  const fieldValuesFormatted = (review.fieldsValues || []).map(fieldValue => {
    const formattedFieldValue = {
      name: fieldValue.name,
      slug: fieldValue.slug,
      type: fieldValue.type,
      options: fieldValue.options,
      multiple: fieldValue.multiple,
    }
    if (fieldValue.value !== undefined) {
      formattedFieldValue.value =
        fieldValue.type === 'file' && fieldValue.file
          ? { id: fieldValue.file.id, url: fieldValue.file.url }
          : fieldValue.value
    }
    return formattedFieldValue
  })
  return {
    id: review.id,
    createdAt: review.createdAt,
    skus: review.skus,
    tags: review.tags,
    internalNote: review.internalNote,
    status: review.status,
    actions: review.actions,
    links: review.links,
    history: review.history,
    additionalData: review.additionalData,
    metadata: review.metadata,
    moderation: review.moderation,
    identity: review.identity,
    review: review.review,
    fieldsValues: fieldValuesFormatted,
  }
}
